import styled, { css } from "styled-components";

export const H1 = styled.h1`
  font-size: 48px;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: 1.44px;

  ${({ theme }) => theme.breakpoints.md.query} {
    font-size: 44px;
  }

  ${({ theme }) => theme.breakpoints.sm.query} {
    font-size: 40px;
  }
`;

export const H2 = styled.h2`
  font-size: 39px;
  font-weight: 500;
  line-height: 100%;
  letter-spacing: 1.17px;

  ${({ theme }) => theme.breakpoints.md.query} {
    font-size: 37px;
  }
`;

export const H3 = styled.h3`
  font-size: 32px;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: 0.96px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 12px;

  ${({ theme }) => theme.breakpoints.md.query} {
    font-size: 30px;
    letter-spacing: 0.9px;
  }
`;

export const H4 = styled.h4`
  font-size: 27px;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: 0.84px;

  ${({ theme }) => theme.breakpoints.md.query} {
    font-size: 28px;
  }
`;

export const H5 = styled.h5`
  font-size: 24px;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: 0.72px;
`;

export const H6 = styled.h6`
  font-size: 19px;
  font-weight: 700;
  line-height: 100%;
  letter-spacing: 0.57px;
`;

export const P = styled.p<{
  $small?: boolean;
  $bold?: boolean;
  $color?: "standard" | "light" | "lightest";
  $textAlign?: string;
}>`
  font-weight: ${({ $bold }) => ($bold ? 900 : 550)};
  line-height: 150%;
  ${({ $small }) =>
  $small
    ? css`
          font-size: 14px;
        `
    : css`
          font-size: 17px;
        `}
  ${({ $color, theme }) => {
  const colorStore = theme.colors.default;
  let colorKey: string | number | undefined;
  switch ($color) {
    case "lightest":
      colorKey = 300;
      break;
    case "light":
      colorKey = 400;
      break;
    case "standard":
      colorKey = "default";
  }

  return css`
      color: ${colorKey ? colorStore[colorKey] : "currentColor"};
    `;
}}
    ${({ $textAlign }) => css`
    text-align: ${$textAlign};
  `}
`;

export const Bold = styled.strong`
  font-weight: 700;
`;

export const Italic = styled.em``;

export const Underline = styled.u``;

export const OrderedList = styled.ol`
  counter-reset: counter;
  display: revert;
  max-width: 100%;

  li {
    display: flex;
    width: 100%;
    max-width: 100%;
    counter-increment: counter;
    gap: 0.72em;

    &::before {
      display: inline-block;
      content: counter(counter) ". ";
      font-weight: 600;
      opacity: 0.5;
      width: 0.4em;
      white-space: nowrap;
    }

    > span {
      display: inline-block;
    }
  }
`;

export const UnorderedList = styled.ul`
  display: revert;
  max-width: 100%;

  li {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    max-width: 100%;
    gap: 0.72em;

    &::before {
      display: inline-block;
      font-weight: 600;
      width: 0.4em;
      height: 0.4em;
      background: currentColor;
      opacity: 0.5;
      border-radius: 0.1em;
      content: "";
      position: relative;
      left: 0.16em;
    }

    > span {
      display: inline-block;
    }
  }
`;

export const Heading = styled.h5`
  font-size: 1.5em;
  font-weight: 700;
`;

export const Quote = styled.blockquote`
  padding: 12px;
  position: relative;
  background: color-mix(in srgb, currentColor 10%, transparent);
  border: 1px solid color-mix(in srgb, currentColor 15%, transparent);
  border-radius: 0.6em;
  width: fit-content;
`;

export const Link = styled.a`
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.primary.default};

  &:hover {
    color: ${({ theme }) => theme.colors.primary[700]};
  }
`;
